module.exports = __webpack_public_path__ + "img/daniel_todtmann.6dcaae53.jpg";